import { render, staticRenderFns } from "./ChooseAirport.vue?vue&type=template&id=b2199886&scoped=true&"
import script from "./ChooseAirport.vue?vue&type=script&lang=js&"
export * from "./ChooseAirport.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAirport.vue?vue&type=style&index=0&id=b2199886&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2199886",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/opt/buildhome/repo/components/global/Spinner.vue').default,AirportCard: require('/opt/buildhome/repo/components/global/AirportCard.vue').default,Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
